import type { SelectProps } from 'antd'
import { Select } from 'antd'
import * as styles from './mobile-select.module.scss'

export const MobileSelect = (props: SelectProps) => {
    return (
        <div className={styles.inputCard}>
            <Select className={styles.mobileSelect} {...props} />
        </div>
    )
}
